import { createContext, useContext } from 'react';

export interface AccessibilityAnnouncerContextType {
    announce: (message: string) => void;
    message: string;
}

const AccessibilityAnnouncerContext = createContext<AccessibilityAnnouncerContextType>({
    announce: () => {},
    message: ''
});

export const useAccessibilityAnnouncer = () => useContext(AccessibilityAnnouncerContext);

export default AccessibilityAnnouncerContext;
